import { TextField } from "@mui/material";
import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, greyMui, purpleMui, redMui } from "@ryde/theme";

export const NumberFieldWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "number-field-wrapper",
})`
  display: flex;
  align-items: center;
  column-gap: 6px;
  padding-block: 3px;
  padding-inline: 7px;
  border: 1px solid ${greyMui._300};
  border-radius: 4px;
  color: ${blueGreyMui._400};
  cursor: pointer;
  svg.circle-x-mark {
    color: ${blueGreyMui.A200};
  }

  &.field__error {
    border-color: ${redMui._500};
  }

  &:hover:not(.field__error) {
    border-color: ${purpleMui._500};
  }
`;

export const TextFieldLabel = styled.label.attrs<IStyledAttributes>({
  "data-e2e": "text-field-label",
})`
  display: flex;
  align-items: center;
  cursor: inherit;
`;

export const TextFieldInputStyled = styled(TextField)`
  & .MuiOutlinedInput-input {
    padding: 0;
    height: 26px;
    width: 40px;
    text-align: center;
  }

  & .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  & .MuiInputBase-adornedEnd {
    padding-inline-start: 0;
  }

  & .MuiInputAdornment-root {
    margin-block-start: 2px;
  }
`;

export const NumberSelectWrapper = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "number-select-wrapper",
})`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & .MuiInputBase-root {
    border: none;
    height: 20px;
  }
`;
